module.exports = __webpack_public_path__ + "static/media/AccessControl.21ed665b.svg";